import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import FocusSection from './components/FocusSection';
import MethodologySection from './components/MethodologySection';
import StatementSection from './components/StatementSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <main>
      <HeroSection />
      <AboutSection />
      <FocusSection />
      <MethodologySection />
      <StatementSection />
      <ContactSection />
    </main>
  );
}